module.exports = __webpack_public_path__ + "static/media/Raleway-Regular.580d0778.ttf";